import {PAGINATOR_SEARCH_MODEL} from "@/dashboard/utils/paginator/paginatedTable";

export const FAMILY_SEARCH_MODEL = {
    ...PAGINATOR_SEARCH_MODEL,
    memberCodes: null
}